export default __webpack_public_path__ + "17- woman water bottle-mobile-horizontal.e8e03b4611f15df9aa6c.png";